import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=142a4afc&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/libs/vue-quill-editor/typography.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/vendor/libs/vue-quill-editor/editor.scss?vue&type=style&index=1&lang=scss&"
import style2 from "@/vendor/styles/pages/users.scss?vue&type=style&index=2&lang=scss&"
import style3 from "@/vendor/libs/vue-form-wizard/vue-form-wizard.scss?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142a4afc')) {
      api.createRecord('142a4afc', component.options)
    } else {
      api.reload('142a4afc', component.options)
    }
    module.hot.accept("./ContactForm.vue?vue&type=template&id=142a4afc&", function () {
      api.rerender('142a4afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/components/contacts/ContactForm.vue"
export default component.exports